import { Base } from '@studiometa/js-toolkit';

/**
 * @typedef {object} EventsListRef
 * @property {HTMLElement[]} events[]
 */

/**
 * @typedef {object} EventsListInterface
 * @property {EventsListRef} $refs
 */

/**
 * Homepage class.
 */
export default class EventsList extends Base {
  /**
   * Class config
   * @type {object}
   */
  static config = {
    name: 'EventsList',
    refs: ['events[]'],
  };

  /**
   * Remove any transforms applied
   */
  mounted() {
    this.$refs.events.forEach((event) => {
      event.style.transform = '';
    });
  }
}
